import { Routes as Router, Route } from 'react-router-dom';
import Home from '../pages/home/Home';
import ConsignadoINSS from '../pages/consignadoINSS/ConsignadoINSS';
import Fgts from '../pages/fgts/Fgts';
import BenefitCard from '../pages/benefitCard/BenefitCard';
import { WithdrawCard } from '../pages/withdrawCard/WithdrawCard';
import Insurance from '../pages/insurance/Insurance';
import Register from '../pages/register/Register';
import Dashboard from '../pages/dashboard/Dashboard';
import Login from '../pages/login/Login';
import Loan from '../pages/dashboard/loan/Loan';
import MyContracts from '../pages/dashboard/my-contracts/MyContracts';
import MyProfile from '../pages/dashboard/my-profile/MyProfile';
import ChangePassword from '../pages/dashboard/change-password/ChangePassword';
import BenefitCardDashboard from '../pages/dashboard/benefit-card/BenefitCard';
import { typeCardEnum } from '../model/enum';

export const Routes = () => {
    return (
        <Router>
            <Route path="/" element={<Home />} />
            <Route path="/emprestimo-consignado" element={<ConsignadoINSS />} />
            <Route path="/saque-fgts" element={<Fgts />} />
            <Route path="/cartao-beneficio" element={<BenefitCard />} />
            <Route path="/saque-cartao" element={<WithdrawCard />} />
            <Route path="/seguro" element={<Insurance />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/loan" element={<Loan />} />
            <Route path="/dashboard/my-contracts" element={<MyContracts />} />
            <Route path="/dashboard/my-profile" element={<MyProfile />} />
            <Route path="/dashboard/change-password" element={<ChangePassword />} />
            <Route path="/dashboard/benefit-card" element={<BenefitCardDashboard typeCard={typeCardEnum.benefit} title={'Cartão Benefício'} />} />
            <Route path="/dashboard/bmg-card" element={<BenefitCardDashboard typeCard={typeCardEnum.bmg} title={'Cartão BMG Card'}/>} />
            <Route path="/dashboard/master-card" element={<BenefitCardDashboard typeCard={typeCardEnum.master} title={'Cartão Master'}/>} />
        </Router>
    );
};
